import { dealsEpic as epic } from './epic'
import { dealsReducer as reducer } from './reducer'

export const dealsEpic = epic
export const dealsReducer = reducer
